import { VuexModule, Module, mutation /*, action*/, getter } from 'vuex-class-component';
import Nullable from '@/types/nullable';

@Module()
export default class AuthStore extends VuexModule {
  @getter public jwt: Nullable<string> = null;

  @mutation public setJwt(jwt: string): void {
    this.jwt = jwt;
  }

  @mutation public clearJwt(): void {
    this.jwt = null;
  }

  public get isLoggedIn(): boolean {
    return this.jwt != null;
  }
}